module.exports = __webpack_public_path__ + "images/green-nature-2-a822a78b97d5328f58ea8edd69dc1f6a.jpg";